import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const { exchangeEmergentSession } = useAuth();
  const nav = useNavigate();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await exchangeEmergentSession(m[1]);
        // clear hash
        window.history.replaceState(null, "", window.location.pathname);
        nav("/dashboard", { replace: true, state: { user } });
      } catch {
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDF8F5]">
      <div className="brut-card p-8 text-center" data-testid="auth-callback">
        <div className="font-heading text-xl font-bold mb-2">Signing you in…</div>
        <div className="text-sm text-slate-500">Hang tight, just a sec.</div>
      </div>
    </div>
  );
}
